<template>
  <div id="modal-backups">
    <b-form-group label="Observaciones" description="Describí qué contiene este respaldo para poder identificarlo después." v-if="hasChanges">
      <div class="php-backups-form">
        <app-textarea
          v-model="form.observations"
          size="sm"
          placeholder="Ej: antes de cambiar la integración de stock"
          rows="2"
          class="php-backups-form__field"
        ></app-textarea>
        <b-button variant="dark" size="sm" @click="generate()" :disabled="!form.observations">
          <AppIcon name="save" class="mr-1" />Generar Respaldo
        </b-button>
      </div>
    </b-form-group>
    <div class="php-backups-notice" v-else>
      <AppIcon name="info-circle" />
      <span>El código actual es igual al del último respaldo — no hay una versión diferente para respaldar.</span>
    </div>

    <hr />

    <div v-if="list.length">
      <div class="php-backups-item" v-for="item in list" :key="item.id">
        <div class="php-backups-item__header" @click="toggle(item)">
          <div class="php-backups-item__date">
            <AppIcon name="clock-history" class="mr-1" />{{ formatDate(item.created_at) }}
          </div>
          <div class="php-backups-item__observations">{{ item.observations }}</div>
          <AppIcon :name="expanded === item.id ? 'chevron-up' : 'chevron-down'" />
        </div>
        <div class="php-backups-item__body" v-if="expanded === item.id">
          <div class="php-snippets-toolbar">
            <span class="php-snippets-toolbar__label"><AppIcon name="data_object" class="mr-1" />Código</span>
            <div>
              <b-button variant="link" size="sm" class="php-snippets-toolbar__copy" @click="copyToClipboard(item.code)">
                <AppIcon name="clipboard" class="mr-1" />Copiar Código
              </b-button>
              <b-button variant="link" size="sm" class="php-backups-item__remove" v-b-tooltip.hover title="Eliminar respaldo" aria-label="Eliminar respaldo" @click="remove(item)">
                <AppIcon name="delete" />
              </b-button>
            </div>
          </div>
          <prism-editor :code="item.code" language="php" class="php-backups-code" :readonly="true"></prism-editor>
        </div>
      </div>
    </div>
    <EmptyState v-else icon="history" title="Sin respaldos" description="Todavía no generaste ningún respaldo de este código." />
  </div>
</template>
<script>
  import serviceAPI from './../services'
  import Error from '@/handler/error'
  import moment from 'moment'

  import PrismEditor from 'vue-prism-editor'
  import "prismjs/components/prism-php"

  export default {
    components: {
      PrismEditor,
    },
    props: {
      phpId: {
        type: [Number, String],
        required: true,
      },
      code: {
        type: String,
        default: '',
      },
      items: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        list: [...this.items],
        expanded: null,
        form: {
          observations: '',
        },
      }
    },
    computed: {
      hasChanges() {
        return !this.list.length || this.list[0].code !== this.code
      }
    },
    watch: {
      phpId() {
        this.list = [...this.items]
        this.expanded = null
        this.form.observations = ''
      }
    },
    methods: {
      formatDate(value) {
        return moment(value).format('DD/MM/YYYY HH:mm')
      },
      toggle(item) {
        this.expanded = this.expanded === item.id ? null : item.id
      },
      generate() {
        let loader = this.$loading.show();

        var result = serviceAPI.agregarPHPBackup(this.phpId, {
          code: this.code,
          observations: this.form.observations,
        })

        result.then((response) => {
          loader.hide()
          this.list.unshift(response.data)
          this.form.observations = ''
          this.$awn.success("Respaldo generado");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      remove(item) {
        this.confirmDialog('¿Desea borrar el respaldo del ' + this.formatDate(item.created_at) + '?', {
          title: 'Borrar Respaldo',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var result = serviceAPI.eliminarPHPBackup(item.id);

            result.then((response) => {
              loader.hide()
              this.list = this.list.filter(i => i.id !== item.id)
              if(this.expanded === item.id) this.expanded = null
              this.$awn.success("Respaldo eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      copyToClipboard(code) {
        var modal = document.getElementById('modal-backups');
        var textarea = document.createElement('textarea');
        textarea.value = code
        modal.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        modal.removeChild(textarea);

        this.$awn.success("Código copiado al portapapeles");
      }
    }
  }
</script>

<style scoped>
  .php-backups-form {
    align-items: flex-end;
    display: flex;
    gap: 12px;
  }
  .php-backups-form__field {
    flex: 1 1 auto;
  }
  .php-backups-notice {
    align-items: flex-start;
    background: var(--app-color-info-soft);
    border: 1px solid var(--app-color-info-200);
    border-radius: 8px;
    color: var(--app-color-info);
    display: flex;
    font-size: var(--app-text-sm);
    gap: 8px;
    padding: 10px 12px;
  }
  .php-backups-item {
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    margin-bottom: 10px;
    overflow: hidden;
  }
  .php-backups-item__header {
    align-items: center;
    cursor: pointer;
    display: flex;
    gap: 12px;
    padding: 10px 12px;
  }
  .php-backups-item__header:hover {
    background: var(--app-color-surface-subtle);
  }
  .php-backups-item__date {
    color: var(--app-color-text-secondary);
    flex: 0 0 auto;
    font-size: var(--app-text-xs);
    font-weight: var(--app-font-semibold);
    white-space: nowrap;
  }
  .php-backups-item__observations {
    color: var(--app-color-text);
    flex: 1 1 auto;
    min-width: 0;
  }
  .php-backups-item__body {
    border-top: 1px solid var(--app-color-border);
  }
  .php-backups-item__remove {
    color: var(--app-color-danger);
    padding: 2px 4px;
  }
  .php-snippets-toolbar {
    align-items: center;
    background: var(--app-color-surface-subtle);
    display: flex;
    justify-content: space-between;
    padding: 6px 10px;
  }
  .php-snippets-toolbar__label {
    align-items: center;
    color: var(--app-color-text-secondary);
    display: inline-flex;
    font-size: var(--app-text-xs);
    font-weight: var(--app-font-semibold);
    text-transform: uppercase;
  }
  .php-snippets-toolbar__copy {
    padding: 2px 4px;
  }
</style>
<style>
  .php-backups-code {
    height: 300px;
  }
  .php-backups-code pre {
    height: 300px;
    margin-top: 0px;
  }
</style>
